/**
 * รู้ตัวเองว่ามี build ใหม่ deploy ขึ้นไปแล้ว — ไม่ต้องรอคนสั่ง reload.hash
 *
 * Nuxt มี plugin check-outdated-build เช็ค `_nuxt/builds/latest.json` ทุก 1 ชม. อยู่แล้ว
 * แต่ไม่มีใครฟัง hook `app:manifest:update` ที่มันยิง — ไฟล์นี้ฟังให้
 * และเช็คเองเพิ่มตอน tab กลับมา / เน็ตกลับมา เพราะ timer ของ tab เบื้องหลังโดนหน่วงจนแทบไม่ทำงาน
 *
 * ตอนนี้แค่จดไว้ (console + Sentry breadcrumb) ยังไม่สั่งโหลดจริง — เปิดได้ที่ onNewBuild()
 * เปิดแล้วทุกเครื่องทุกร้านจะโหลดใหม่เองหลัง deploy (เมื่อว่าง สุ่มภายใน 60 วิ)
 */
import * as Sentry from "@sentry/vue";
import { buildAssetsURL } from "#internal/nuxt/paths";

/** เช็คถี่สุดเท่านี้ — tab สลับไปมาบ่อยไม่ควรยิง request ทุกครั้ง */
const CHECK_THROTTLE_MS = 5 * 60 * 1000;

export default defineNuxtPlugin((nuxtApp) => {
  const currentBuildId = useRuntimeConfig().app.buildId;
  let lastCheckAt = 0;
  let reportedBuildId: string | null = null;

  function onNewBuild(buildId: string) {
    if (!buildId || buildId === currentBuildId || buildId === reportedBuildId) return;
    reportedBuildId = buildId;

    console.info("[deployCheck] มี build ใหม่", { current: currentBuildId, latest: buildId });
    try {
      Sentry.addBreadcrumb({
        category: "app-reload",
        level: "info",
        message: "new build detected",
        data: { current: currentBuildId, latest: buildId },
      });
    } catch {}

    // ปิดไว้ก่อน — เปิดเมื่อพร้อมให้ทุกเครื่องโหลดใหม่เองหลัง deploy
    // useAppControlStore().requestReload({
    //   source: "deploy",
    //   key: `deploy:${buildId}`,
    //   reason: `build ใหม่ ${buildId}`,
    //   jitter: true,
    // });
  }

  async function checkLatestBuild() {
    if (Date.now() - lastCheckAt < CHECK_THROTTLE_MS) return;
    lastCheckAt = Date.now();
    try {
      const meta = await $fetch<{ id?: string }>(buildAssetsURL("builds/latest.json") + `?${Date.now()}`);
      if (meta?.id) onNewBuild(meta.id);
    } catch {
      // ออฟไลน์ / dev ไม่มีไฟล์นี้ — รอบหน้าค่อยเช็คใหม่
    }
  }

  nuxtApp.hook("app:manifest:update", (meta) => {
    if (meta?.id) onNewBuild(meta.id);
  });

  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") checkLatestBuild();
  });
  window.addEventListener("pageshow", () => checkLatestBuild());
  window.addEventListener("online", () => checkLatestBuild());
});
